<template>
    <transition name="el-alert-fade">
        <div class="vue-alert" :class="[typeClass, center ? 'vue-alert_center' : '']" v-show="visible" role="alert">
            <i class="vue-alert__icon" :class="[ iconClass, isBigIcon ]" v-if="showIcon"></i>
            <div class="vue-alert__content">
                <span class="vue-alert__title" :class="[ isBoldTitle ]" v-if="title || $slots.title">
                  <slot name="title">{{ title }}</slot>
                </span>
                <span class="vue-alert__description" v-if="description && !$slots.description">
                    <slot>{{ description }}</slot>
                </span>
                <span class="vue-alert__description" v-if="$slots.description && !description">
                    <slot name="description"></slot>
                </span>
                <i class="vue-alert__close-btn" :class="{ 'is-customed': closeText !== '', 'fa fa-times': closeText === '' }" v-show="closable" @click="close()">{{closeText}}</i>
            </div>
        </div>
    </transition>
</template>

<script type="text/babel">
    const TYPE_CLASSES_MAP = {
        'success': 'fa fa-check-circle',
        'warning': 'fa fa-exclamation-triangle',
        'error': 'fa fa-times-circle-o'

    };
    export default {
        name: 'vueAlert',
        props: {
            title: {
                type: String,
                default: ''
            },
            description: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'info'
            },
            closable: {
                type: Boolean,
                default: true
            },
            closeText: {
                type: String,
                default: ''
            },
            showIcon: Boolean,
            center: Boolean
        },
        data() {
            return {
                visible: true
            };
        },
        methods: {
            close() {
                this.visible = false;
                this.$emit('close');
            }
        },
        computed: {
            typeClass() {
                return `vue-alert_${ this.type }`;
            },
            iconClass() {
                return TYPE_CLASSES_MAP[this.type] || 'fa fa-info-circle';
            },
            isBigIcon() {
                return this.description || this.$slots.default ? 'vue-alert__icon_big' : '';
            },
            isBoldTitle() {
                return this.description || this.$slots.default ? 'vue-alert__title_bold' : '';
            }
        }
    };
</script>